import { render, staticRenderFns } from "./nfegeral.items.vue?vue&type=template&id=90422dca&"
import script from "./nfegeral.items.vue?vue&type=script&lang=js&"
export * from "./nfegeral.items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports